// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__IpDT5","load":"Loader_load__w7gO9"};